import * as v from "valibot";
import { BaseRecordSchema, baseVals, defineValidation } from "../../common/validation.common";

export namespace NetworkUsageValidation {
    export const Record = defineValidation(BaseRecordSchema);

    export const Create = defineValidation(
        v.object({
            address: baseVals.ipv4(),
            groupId: v.string(),
        }),
    );
}
